import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  canonical: string;
  keywords?: string;
  ogImage?: string;
  schema?: object | object[];
}

const BASE_URL = "https://missedcallrescuecanada.com";

const SEO = ({ title, description, canonical, keywords, ogImage, schema }: SEOProps) => {
  const fullCanonical = canonical.startsWith("http") ? canonical : `${BASE_URL}${canonical}`;
  const image = ogImage || "https://vibe.filesafe.space/1776204073728798439/assets/b8d5f400-54a8-46f6-8f79-fcf7d173d4ab.png";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={fullCanonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullCanonical} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        Array.isArray(schema) ? (
          schema.map((s, i) => (
            <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
          ))
        ) : (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        )
      )}
    </Helmet>
  );
};

export { SEO, BASE_URL };
